'use client';

import type { SyntheticEvent } from 'react';

import { BodySmall } from '#/components/Text/BodySmall';

import { CurrentPage, PageLink } from './Pagination.styled';

type Props = {
  href: string;
  pageNumber: number;
  selected: boolean;
  onClick?: (event: SyntheticEvent<HTMLAnchorElement>) => void;
};

export function Page({ href, pageNumber, selected, onClick }: Props) {
  if (selected) {
    return (
      <CurrentPage qaId="pagination-current-page">
        <BodySmall>{pageNumber + 1}</BodySmall>
      </CurrentPage>
    );
  }

  return (
    <PageLink qaId="pagination-link" onClick={onClick} href={href}>
      <BodySmall>{pageNumber + 1}</BodySmall>
    </PageLink>
  );
}
